import { supabase } from '../config/supabase';

/**
 * Obtiene todos los productos activos
 * @returns {Promise<Array>} Lista de productos
 */
export const obtenerProductos = async () => {
  try {
    const { data, error } = await supabase
      .from('productos')
      .select('*')
      .eq('activo', true)
      .order('nombre');

    if (error) throw error;
    return data;
  } catch (error) {
    console.error('Error al obtener productos:', error);
    throw error;
  }
};

/**
 * Obtiene un producto por ID
 * @param {string} id - ID del producto
 * @returns {Promise<Object>} Producto
 */
export const obtenerProducto = async (id) => {
  try {
    const { data, error } = await supabase
      .from('productos')
      .select('*')
      .eq('id', id)
      .single();

    if (error) throw error;
    return data;
  } catch (error) {
    console.error('Error al obtener producto:', error);
    throw error;
  }
};

/**
 * Crea un nuevo producto
 * @param {Object} producto - Datos del producto
 * @returns {Promise<Object>} Producto creado
 */
export const crearProducto = async (producto) => {
  try {
    const { data, error } = await supabase
      .from('productos')
      .insert([{
        nombre: producto.nombre,
        precio: producto.precio,
        descripcion: producto.descripcion,
        imagen_url: producto.imagen_url || null
      }])
      .select()
      .single();

    if (error) throw error;
    return data;
  } catch (error) {
    console.error('Error al crear producto:', error);
    throw error;
  }
};

/**
 * Actualiza un producto
 * @param {string} id - ID del producto
 * @param {Object} producto - Datos a actualizar
 * @returns {Promise<Object>} Producto actualizado
 */
export const actualizarProducto = async (id, producto) => {
  try {
    const { data, error } = await supabase
      .from('productos')
      .update({
        nombre: producto.nombre,
        precio: producto.precio,
        descripcion: producto.descripcion,
        imagen_url: producto.imagen_url,
        updated_at: new Date().toISOString()
      })
      .eq('id', id)
      .select()
      .single();

    if (error) throw error;
    return data;
  } catch (error) {
    console.error('Error al actualizar producto:', error);
    throw error;
  }
};

/**
 * Elimina (desactiva) un producto
 * @param {string} id - ID del producto
 * @returns {Promise<Object>} Producto desactivado
 */
export const eliminarProducto = async (id) => {
  try {
    const { data, error } = await supabase
      .from('productos')
      .update({
        activo: false,
        updated_at: new Date().toISOString()
      })
      .eq('id', id)
      .select()
      .single();

    if (error) throw error;
    return data;
  } catch (error) {
    console.error('Error al eliminar producto:', error);
    throw error;
  }
};
